<template>
  <div class="shopping-cart-section__ordering">
    <span class="shopping-cart-section__ordering-title shopping-cart-section__column-title">Place order</span>
    <form class="shopping-cart-section__form" @submit.prevent="storeOrder">
      <div class="form-group form-style">
        <input
                class="form-control"
                id="orderingName"
                type="text"
                placeholder="Your name"
                v-model.trim="user_name"
        />
      </div>

      <div class="form-group form-style">
        <the-mask mask="+1 (###) ###-####"
                  v-model.trim="user_phone"
                  class="form-control"
                  id="orderingPhone"
                  placeholder="+1 (___) ___-____"
                  type="tel"
                  required
        />
      </div>

      <b-button
              class="btn btn-dark shopping-cart-section__form-btn"
              type="submit"
              :disabled="loading || list.length === 0"
      >
        <b-spinner small v-if="loading"></b-spinner>
        <span v-else>Send</span>
      </b-button>
    </form>
    <p class="shopping-cart-section__ordering-text">
      We will contact you within 10 <br/>
      minutes after submitting the form
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ShopCartOrderForm',
  data: () => ({
    loading: false,
    user_name: null,
    user_phone: null,
  }),
  computed: {
    ...mapGetters('shop_card', ['list']),
  },
  methods: {
    ...mapMutations('shop_card', ['setOrderedStatus']),
    ...mapActions('shop_card', ['store']),
    storeOrder () {
      this.loading = true
      axios.post('/api/order/', { user_name: this.user_name, user_phone: this.user_phone, products: this.list }).
        then(({ status }) => {
          if (status === 200) {
            this.setOrderedStatus()
            this.store([])
            window.trackLead()
          }
        }).
        catch(error => {
          this.showMsgBoxTwo()
          console.log(error)
        }).
        finally(() => this.loading = false)
    },
    showMsgBoxTwo () {
      this.$bvModal.msgBoxConfirm('An error occurred while sending. Please reload the page and try again.', {
        title: '1',
        size: 'sm',
        footerClass: 'd-none',
        hideHeaderClose: false,
        centered: true,
        hideFooter: true,
        headerClass: 'error-header',
      }).then(value => {
        this.boxTwo = value
      }).catch(err => {
        // An error occurred
      })
    },
  },

}
</script>

<style>
  .modal .error-header button.close {
    color: transparent;
  }

  .modal .error-header .modal-title {
    display: none;
  }
</style>
